import { useCallback, useEffect, useRef, useState } from "react";
import ReactLoading from "react-loading";
import { useSearchParams } from "react-router-dom";
import { api } from "../api";
import { useInterval } from "react-use"
import classNames from "classnames";
import axios from 'axios'

async function loadImageAsync(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    axios.get(src, {
      responseType: 'blob', 
    })
      .then(response => {
        const imageUrl = URL.createObjectURL(response.data);
        img.onload = () => {
          URL.revokeObjectURL(imageUrl); // Clean up the object URL after the image is loaded
          resolve(img);
        };
        img.onerror = (error) => reject(error);
        img.src = imageUrl;
      })
      .catch(error => {
        console.error('Failed to load image', error);
        reject(error)
      });
  });
}

const Snapshot = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const branch_id = searchParams.get("branch_id");
  const token = searchParams.get("token");

  const canvasRef = useRef<HTMLCanvasElement>(null);
  const urlRef = useRef<string | null>(null);
  const [initialLoading, setInitialLoading] = useState(true);

  const drawImage = useCallback(async () => {
    if (!canvasRef.current) return;

    const ctx = canvasRef.current.getContext('2d');

    if (!ctx) return;

    try {
      if (!urlRef.current) {
        const response = await api.get(`/contests/leaderboard/${branch_id}/snapshot`, {
          headers: {
            "Authorization": token ? `Bearer ${token}` : "",
          },
          params: {
            token: id ? id : null
          },
        });
        urlRef.current = response.data.url
      }
      const img = await loadImageAsync(urlRef.current!);
      ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvasRef.current.width, canvasRef.current.height);
      setInitialLoading(false);
    } catch (err) {
      urlRef.current = null;
      setInitialLoading(true);
    }
  }, [branch_id, token, id]);

  useEffect(() => {
    drawImage();
  }, [drawImage]);

  useInterval(async () => {
    drawImage();
  }, 5000)

  return (
    <div className="flex items-center h-full overflow-hidden">
      <canvas 
        ref={canvasRef}
        data-testid="camera_screenshot"
        className={classNames("w-full h-auto rounded-lg", {
          'hidden': initialLoading
        })}
      />
      {initialLoading && (
        <div className="w-full h-full flex items-center justify-center" data-testid="loading">
          <ReactLoading width={32} type="spin" color="gray" />
        </div>)}
    </div>
  );
};

export default Snapshot;
